import React from "react";
import { Card, Row, Col, List, Statistic, Switch, Button, Divider,Tabs } from "antd";
import { PoweroffOutlined } from "@ant-design/icons";

const ServerOverview = () => {

  const activities = [
    "Server console requested",
    "Server started",
    "Server created",
    "Backups enabled",
    "Primary IP created",
  ];

  return (
    <div>
        
<Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={4}>
          <Card>
            <Statistic title="VCPU" value={4} />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic title="RAM" value="8 GB" />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic title="DISK LOCAL" value="80 GB" />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic title="USAGE" value={5.11} />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic title="TRAFFIC OUT" value="0/20 TB" />
          </Card>
        </Col>
        <Col span={4}>
          <Card>
            <Statistic title="PRICE" value="$5.99/mo" />
          </Card>
        </Col>
      </Row>

      {/* Activities and Options */}
      <Row gutter={16}>
        <Col span={12}>
          <Card title="Activities" style={{ marginBottom: 16 }}>
            <List
              dataSource={activities}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Options" style={{ marginBottom: 16 }}>
            <Button type="default" style={{ marginRight: 8 }}>Disable Backups</Button>
            <Button type="default" style={{ marginRight: 8 }}>Select Group</Button>
            <Button type="default" disabled>Public Network</Button>
          </Card>

          <Card title="Location">
            <p>DATACENTER: nbg1-dc3</p>
            <p>CITY: Nuremberg</p>
            <p>COUNTRY: Germany</p>
            <p>NETWORK ZONE: eu-central</p>
          </Card>
        </Col>
      </Row>

    </div>
  );
};

export default ServerOverview;
